import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faSync } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useAccountingIntegration from '@hooks/useAccountingIntegration'
import useCreditNote from '@hooks/useCreditNote'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { CreditNoteModel } from '@models/types'

const defaultState = {
  loading: false,
}

type InvoiceActionButtonProps = {
  accountingPayload: ReturnType<typeof useAccountingIntegration>,
  creditNote: CreditNoteModel,
}

const CreditNoteActionButton = (props: InvoiceActionButtonProps) => {
  const {
    accountingPayload: { hasActiveSession },
    creditNote,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  const creditNotePayload = useCreditNote(creditNote)

  const {
    callbacks: { createExternalCreditNote: createFn },
  } = creditNotePayload

  const getSyncData = digObject(creditNote, 'data.xero_id', false)
  const isSynced = !!getSyncData

  const createCreditNotePayload = {
    callbacks: {
      action: createFn,
      afterAction: () => setState({ loading: false }),
      afterError: () => setState({ loading: false }),
    },
    toastText: 'Credit Note Created',
  }

  return (
    <>
      {hasActiveSession && !isSynced && (
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faLink} />}
          loading={loading}
          onClick={() => {
            setState({ loading: true })
            // @ts-expect-error TS2345
            handleCallbackAction(createCreditNotePayload)
          }}
          size="small"
          // @ts-expect-error TS2322
          fontSize="xsmall"
        >
          Create in Xero
        </Button>
      )}

      {hasActiveSession && isSynced && (
        <Button
          buttonStyle="secondaryEdit"
          disabled
          icon={<FontAwesomeIcon icon={faSync} />}
          size="small"
          // @ts-expect-error TS2322
          fontSize="xsmall"
        >
          Synced
        </Button>
      )}
    </>
  )
}

export default CreditNoteActionButton
